<div class="container-fluid">
  <app-page-header
    icon="fe-globe"
    pretitle="Configurações"
    title="Portal público"
    description="Endereços para divulgar no site da empresa — quem participa não precisa de conta."
  />
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-12 col-xl-6">
      <div class="card">
        <div class="card-header">
          <div class="d-flex align-items-center">
            <span class="avatar avatar-sm me-3">
              <span class="avatar-title fs-lg rounded bg-primary-soft text-primary"><i class="fe fe-edit-3"></i></span>
            </span>
            <h4 class="card-header-title mb-0">Registar uma participação</h4>
          </div>
        </div>
        <div class="card-body">
          <p class="text-muted small">
            Reclamações, sugestões, elogios e denúncias — de forma anónima ou identificada. Cada participação
            entra em <strong>triagem</strong> e devolve um código de acompanhamento a quem participou.
          </p>
          <div class="input-group input-group-sm mb-2">
            <input class="form-control" type="text" readonly [value]="submitUrl()" />
            <button class="btn btn-primary" type="button" (click)="copy(submitUrl())">
              <i class="fe fe-copy me-1"></i>{{ copied() === submitUrl() ? 'Copiado!' : 'Copiar' }}
            </button>
          </div>
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="open(submitUrl())">
            <i class="fe fe-external-link me-1"></i>Abrir numa aba nova
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-6">
      <div class="card">
        <div class="card-header">
          <div class="d-flex align-items-center">
            <span class="avatar avatar-sm me-3">
              <span class="avatar-title fs-lg rounded bg-info-soft text-info"><i class="fe fe-search"></i></span>
            </span>
            <h4 class="card-header-title mb-0">Acompanhar pelo código</h4>
          </div>
        </div>
        <div class="card-body">
          <p class="text-muted small">
            Com o código recebido no registo, qualquer pessoa consulta o estado da sua participação.
            A página mostra só o estado e as datas — nunca dados de quem participou.
          </p>
          <div class="input-group input-group-sm mb-2">
            <input class="form-control" type="text" readonly [value]="trackUrl()" />
            <button class="btn btn-primary" type="button" (click)="copy(trackUrl())">
              <i class="fe fe-copy me-1"></i>{{ copied() === trackUrl() ? 'Copiado!' : 'Copiar' }}
            </button>
          </div>
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="open(trackUrl())">
            <i class="fe fe-external-link me-1"></i>Abrir numa aba nova
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body d-flex align-items-start gap-3">
      <span class="avatar avatar-sm">
        <span class="avatar-title fs-lg rounded bg-secondary-soft text-secondary"><i class="fe fe-info"></i></span>
      </span>
      <div>
        <h4 class="mb-1">Como divulgar</h4>
        <p class="text-muted small mb-0">
          Ponha o primeiro endereço num botão do site (“Participar / Denunciar”) e o segundo junto dele
          (“Já participou? Acompanhe”). As participações chegam a Ocorrências, em triagem, e a equipa é
          notificada.
        </p>
      </div>
    </div>
  </div>
</div>
